// Upsell Price Fix v2.3 - Fixes cents-to-dollars conversion
(function() {
  if (window.location.pathname !== '/cart') return;
  
  console.log('Upsell fix script loaded');
  
  var fixAttempts = 0;
  function fixUpsellPrices() {
    fixAttempts++;
    if (fixAttempts > 30) return;
    
    var priceElements = document.querySelectorAll('.digifiy-upsell__price-now, .digifiy-upsell__price-was');
    if (priceElements.length === 0) {
      setTimeout(fixUpsellPrices, 300);
      return;
    }
    
    var fixed = 0;
    priceElements.forEach(function(el) {
      if (el.getAttribute('data-price-fixed')) return;
      var text = el.textContent.trim();
      
      // Check for PKR prices that are 100x too high
      var match = text.match(/Rs\.([\d,]+)\.(\d+) PKR/);
      if (match) {
        var numStr = match[1].replace(/,/g, '');
        var decimal = match[2];
        var num = parseFloat(numStr + '.' + decimal);
        if (num > 50000) {
          var corrected = (num / 100);
          var formatted = corrected.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          el.textContent = 'Rs.' + formatted + ' PKR';
          el.setAttribute('data-price-fixed', 'true');
          fixed++;
        }
      }
      
      // Also check for USD prices that are way too high
      var usdMatch = text.match(/\$([\d,]+)\.(\d+)/);
      if (usdMatch) {
        var usdStr = usdMatch[1].replace(/,/g, '');
        var usdDec = usdMatch[2];
        var usdNum = parseFloat(usdStr + '.' + usdDec);
        if (usdNum > 200) {
          var fixedUsd = (usdNum / 100);
          el.textContent = '$' + fixedUsd.toFixed(2);
          el.setAttribute('data-price-fixed', 'true');
          fixed++;
        }
      }
    });
    
    if (fixed > 0) {
      console.log('Fixed', fixed, 'upsell prices');
    } else {
      // Keep trying in case prices aren't loaded yet
      setTimeout(fixUpsellPrices, 500);
    }
  }
  
  if (document.readyState === 'complete') {
    setTimeout(fixUpsellPrices, 500);
  } else {
    window.addEventListener('load', function() { setTimeout(fixUpsellPrices, 500); });
  }
  
  // Also observe for dynamic content
  var observer = new MutationObserver(function(mutations) {
    var hasUpsell = false;
    for (var m of mutations) {
      if (m.addedNodes.length > 0) {
        for (var n of m.addedNodes) {
          if (n.nodeType === 1 && (n.classList?.contains('digifiy-upsell__item') || n.querySelector?.('.digifiy-upsell__item'))) {
            hasUpsell = true;
            break;
          }
        }
      }
    }
    if (hasUpsell) setTimeout(fixUpsellPrices, 100);
  });
  observer.observe(document.body, {childList: true, subtree: true});
})();
